import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { PaginaExterna } from "../../Componentes/Compuestos/Paginas/PaginaExterna";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { NumberBox } from "devextreme-react";
import { function_VEN_Reservas_Cabecera_Leer } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import { function_ABM_EEX_Clientes_LeerPorDNISinPassword } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";

export const _EXT_Reservas_Buscador = () => {

  const { CodigoCompania, CodigoEmpresa, CodigoPlanta, IdReserva, IdItem } = useParams();
  const [idReserva, setIdReserva] = useState(0);
  const [cuit, setCUIT] = useState("");
  const [detalles, setDetalles] = useState([]);

  const handleCuitOnValueChanged = (e) => {
    setCUIT(e.value)
  }

  const handleIdReservaOnValueChanged = (e) => {
    setIdReserva(e.value)
  }
  useEffect(() => {

  }, []);

  const onClickGuardar = () => {

    if (!cuit || !idReserva) {
      alert("Todos los campos son obligatorios.");
      return;
    }

    try {

      const guardar = async () => {

        const resultReserva = await function_VEN_Reservas_Cabecera_Leer(idReserva)
        const resultCliente = await function_ABM_EEX_Clientes_LeerPorDNISinPassword(cuit)

        // Verifica que IdClienteGenerador sea igual a cuit
        if (resultReserva.data.DNI != cuit) {
          alert("El D.N.I. no coincide con el de la persona que generó la Reserva.");
          return;
        }
        
        setDetalles(resultReserva.data.Detalles);
      }

      guardar();

    } catch (error) {
      alert("Hubo problemas con la Reserva.");
    }
  };


  return (

    <div>
      <PaginaExterna
        CodigoCompania={CodigoCompania}
        CodigoEmpresa={CodigoEmpresa}
        CodigoPlanta={CodigoPlanta} >

        <table width={'100%'} >
          <tbody>
            <tr>
              <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
                <NumberBox
                  label="Reserva"
                  value={idReserva}
                  onValueChanged={handleIdReservaOnValueChanged} />
              </td>
            </tr>
            <tr>
              <td style={{ margin: '10px', padding: '5px' }} colSpan={2}>
                <NumberBox
                  label="D.N.I."
                  value={cuit}
                  onValueChanged={handleCuitOnValueChanged}
                />
              </td>
            </tr>

            <tr>
              <td style={{ margin: '10px', padding: '5px' }} >
                <LVButtonAccion Texto="BUSCAR" Ancho={'100%'} onClick={onClickGuardar} />
              </td>
            </tr>

            {detalles.length > 0 && (
              <tr>
                <td colSpan={2}>
                  {detalles.map((detalle, index) => (
                    <div key={index} style={{ margin: '10px', padding: '5px' }}>
                      <a
                        href={`https://neftis.com.ar/participante.html?IdReserva=${idReserva}&IdItem=${detalle.IdItem}&CodigoCompania=${CodigoCompania}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        HACE CLICK ACA PARA CARGAR LOS PARTICIPANTES PARA LA ACTIVIDAD {detalle.Articulo}
                      </a>
                    </div>
                  ))}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </PaginaExterna>
    </div>
  );
};
